import DesignSystemEditor from 'components/DesignSystemEditor';
import { SUPPORT_EMAIL } from '@constants';
import ErrorOverlay from 'components/Widget/Overlay/ErrorOverlay';
import * as S from './styles';
import { shallowEqual, useSelector } from 'react-redux';
import { selectIsMobile } from 'redux/mode/reducers';
import { RootReducer } from 'redux/reducers';

const DesignSystemLayout = () => {
	const { isMobile, designSystemLoadError } = useSelector((r: RootReducer) => {
		return {
			isMobile: selectIsMobile(r.mode),
			designSystemLoadError: r.db.designSystemLoadError,
		};
	}, shallowEqual);

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	if (designSystemLoadError) {
		return <ErrorOverlay text={designSystemLoadError} showProjectsLink />;
	}

	return isMobile ? (
		<S.Base>
			<S.Content>
				<S.Title>DS Editor Unavailable</S.Title>
				<S.Info>
					<p>Mobile device detected.</p>
					<p>
						The Design System Editor is not available on mobile devices. Please load this page on a
						desktop browser to view and edit this design system.
					</p>
					<p>
						If you believe you received this message in error, please{' '}
						<a href={`mailto:${SUPPORT_EMAIL}?subject=Design%20System%20Editor%20Access%20Issue`}>
							let us know
						</a>
						.
					</p>
				</S.Info>
			</S.Content>
		</S.Base>
	) : (
		<S.Base>
			<DesignSystemEditor />
		</S.Base>
	);
};

export default DesignSystemLayout;
